import { Option } from "@recore-solutions/nstar-lib";

export const pageSizes: Option[] = [
	{ key: "10", value: "10", sortOrder: 1 },
	{ key: "25", value: "25", sortOrder: 2 },
	{ key: "50", value: "50", sortOrder: 3 },
];
